module.exports = __webpack_public_path__ + "front/img/10.9ca9b8a0.png";